import { useMemo } from "react";
import { getPauseEnrollmentValidation } from "../../study.plans/study.plan/validations/validate.study.plan";

export const useEnrollmentVariationsValidation = (enrollmentVariations) => {
  const alerts = useMemo(() => [
    {
      condition: enrollmentVariations.every(
        (item) => parseFloat(item.enrollmentSeasonalVariation) === 0,
      ),
      message: "At least one month for each country must have a non-zero value for Country Enrollment Seasonal Variations.",
    },
  ], [enrollmentVariations]);
  return alerts;
}

export const usePauseValidation = (
  numberPatientsEnrolled,
  PauseEnrollment,
  screenFailRate,
  numberPatientsScreened,
) => {
  const alerts = useMemo(() => {
    const { isInvalid, message } = getPauseEnrollmentValidation(
      numberPatientsEnrolled,
      PauseEnrollment,
      screenFailRate,
      numberPatientsScreened,
    );
    
    return [{
      condition: isInvalid,
      message,
    }];
    // eslint-disable-next-line
  }, [numberPatientsEnrolled,
    PauseEnrollment,
    screenFailRate,
    numberPatientsScreened,
  ]);
  return alerts;
}